module.exports = __webpack_public_path__ + "static/img/iconTestData.d81ec1a.png";